import { personConnectionService } from "../../../services/connections/personConnectionService";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import {
  PersonConnection,
  PersonConnectionFilters,
} from "../../../types/personConnection";
import usePersonConnectionLogic from "../../logic/connections/personConnectionLogic";
import useConnectionQueryClient from "./connectionQueryClient";

const usePersonConnectionQuery = () => {
  const { defaultPersonConnection, getDisplayName } = usePersonConnectionLogic(
    null,
    null
  );
  return useConnectionQueryClient<PersonConnection, PersonConnectionFilters>({
    service: personConnectionService,
    collection: SystemEntityCollections.PERSON_CONNECTION,
    defaultConnection: defaultPersonConnection,
    snackbarDisplayName: getDisplayName,
  });
};

export default usePersonConnectionQuery;
